import { getCollapsiblePanelStyles, getStepStyles } from '../../shared/styles';

export const getStyles = (components, theme) => ({
  collapsiblePanel: {
    ...getCollapsiblePanelStyles(components, theme),
    '& .jumbo-card-control-all-btn-stack': {
      width: '20%',
    },
    '& .panel-heading': {
      padding: 0,
      borderBottom: 'none',
      marginBottom: 18,
      display: 'flex',

      '& .panel-title': {
        fontSize: 18,
        width: '80%',
        '& > a': {
          color: theme.palette.themePrimary,
          padding: 0,
          '&:hover, &:active': {
            color: theme.palette.themeDarker,
            textDecoration: 'none',
            backgroundColor: 'unset',
          },
        },

        '& > a:after': {
          transform: 'rotate(180deg)',
        },

        '& > a.collapsed:after': {
          transform: 'rotate(90deg)',
        },
      },
    },
  },
  bidAndTargetStep: {
    ...getStepStyles(),
  },
});
